import React, { useState, useEffect } from 'react';

import { CancelSubmitButton, SearchButton } from '../../Res/BaseButton';
import { ContentBox } from '../ContentBox';
import { getval2Token, getUserInfoCompanyId, setVal2Token } from '../../../Login/Auth';
import { SingleText, SingleSelect } from '../../Res/BaseInput';
import moment from 'moment';
import { contractorAttendanceStatusAttr, ReqContractorAttendance, CustomerPositionListItem, ReqContractorAttendanceRecruitmentList, ReqContractorAttendanceRecruitmentContractor, contractorAttendanceStatusAttr_Register } from '../../../../item/ItemContractorAttendance';
import { api_updateContractorAttendance, api_getCustomerAttendance_CustomerPosition_Recruitment_List, api_getCustomerAttendance_CustomerPosition_Recruitment_Contractor } from '../../../../api/apiContractorAttendancee';
import { WageType2, RespCustomerPositionDetail, getMarginCalculationTypeString, getBusinessTaxTypeString, getInsuranceBurdenTypeString, getGroupInsuranceTypeString, RespCustomerPositionInfo, WageType1 } from '../../../../item/ItemCustomerPosition';
import Swal from 'sweetalert2';
import { ReqRecruitmentContractorCaseInfo } from '../../../../item/ItemRecruitmentContractor';
import {ContractorAttendanceRegisterAttachment} from './ContractorAttendanceRegisterAttachment'
import { ContractorAttendanceRegisterHourlyRecruitmentList } from './ContractorAttendanceRegisterHourlyRecruitmentList';
import { ReqRecruitmentItem_SalaryHourly } from '../../../../item/ItemContractorAttendance_RecruitmentItem_SalaryHourly';


export function ContractorAttendanceRegisterHourly({ id, setIsLoading }) {
  const [tokenId, setTokenId] = useState("")
  const [contractorAttendance, setContractorAttendance] = useState({})
  const [attachment, setAttachment] = useState({})

  const [companyId] = useState(getUserInfoCompanyId())
  const [contractorAttendanceId, setContractorAttendanceId] = useState("")
  const [customerContractId, setCustomerContractId] = useState("")
  const [contractorAttendanceSOPName, setContractorAttendanceSOPName] = useState("")
  const [creatAt, setCreatAt] = useState("")
  const [creatName, setCreatName] = useState("")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [dates, setDates] = useState("")
  const [Status, setStatus] = useState("")

  const [CustomerPositionListItems, setCustomerPositionListItems] = useState([])
  const [RecruitmentList, setRecruitmentList] = useState([])

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      setTokenId(id)
      var obj = getval2Token("salaryHourly", id)
      console.log(obj)
      var salaryHourly = obj.salaryHourly
      var mReqContractorAttendance = new ReqContractorAttendance({})
      mReqContractorAttendance.fromJson(obj.contractorAttendance)
      setContractorAttendance(mReqContractorAttendance)
      setAttachment(salaryHourly.attachment)
      console.log(salaryHourly)
      console.log(mReqContractorAttendance)
      setContractorAttendanceId(mReqContractorAttendance.contractorAttendanceId)
      setContractorAttendanceSOPName(mReqContractorAttendance.contractorAttendanceSOPName)
      setCreatAt(moment(mReqContractorAttendance.creatAt).format('YYYY/MM/DD HH:mm:ss'))
      setCreatName(obj.contractorAttendance.creatName)
      setStartDate(moment(mReqContractorAttendance.startDate).format('YYYY/MM/DD'))
      setEndDate(moment(mReqContractorAttendance.endDate).format('YYYY/MM/DD'))
      setDates(obj.contractorAttendance.dates)
      setStatus(salaryHourly.Status)
      // setContractorAttendanceId(obj.contractorAttendanceId)
      setCustomerContractId(mReqContractorAttendance.customerContractId)

      setCustomerPositionListItems(salaryHourly.CustomerPositionListItems)
      setRecruitmentList(salaryHourly.RecruitmentList)

      // setContractorAttendanceSOPName(obj.contractorAttendanceSOPName)
      // const startDate = moment(obj.startDate).format('YYYY/MM/DD')
      // const endDate = moment(obj.endDate).format('YYYY/MM/DD')
      // if (startDate)
      //   setDates(startDate + "～" + endDate)
    }
  }, [id])


  function getPositionList() {
    if (customerContractId === undefined || customerContractId === "") return
    Swal.fire({
      type: 'warning',
      title: "已經登錄的資料會遺失",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      allowEscapeKey: false,
      allowOutsideClick: false
    }).then(function (result) {
      // console.log(result)
      if (result.value) {
        if (setIsLoading !== undefined)
          setIsLoading(true)
        var mReqCustomerPositionList = new ReqContractorAttendanceRecruitmentList({
          customerContractId,
          wageType: WageType1,
          companyId,
          startDate,
          endDate
        })
        // console.log(mReqCustomerPositionList)
        api_getCustomerAttendance_CustomerPosition_Recruitment_List({
          mReqCustomerPositionList,
          success: (obj) => {
            // console.log(obj)

            var RecruitmentList = []
            obj.RecruitmentList.map((Recruitment) => {
              console.log(Recruitment)
              var caseInfo = new ReqRecruitmentContractorCaseInfo({})
              caseInfo.fromJson(Recruitment.caseInfo)
              var PositionInfo = new RespCustomerPositionInfo({})
              PositionInfo.fromJson(Recruitment.info)
              console.log(PositionInfo)
              var mReqRecruitmentItem_SalaryHourly = new ReqRecruitmentItem_SalaryHourly({ Recruitment, caseInfo, PositionInfo, startDate, endDate })
              console.log(mReqRecruitmentItem_SalaryHourly)
              RecruitmentList.push(mReqRecruitmentItem_SalaryHourly)
            })
            setRecruitmentList(RecruitmentList)

            var creatAt = moment().format('YYYY/MM/DD HH:mm:ss')
            var mCustomerPositionListItems = []
            obj.CustomerPositionList.map((item) => {
              var CustomerPositionDetail = new RespCustomerPositionDetail({})
              CustomerPositionDetail.fromJson(item)
              var rs = RecruitmentList.filter(function (obj, index, array) {
                return obj.customerPositionId === item.customerPositionId
              });
              var mCustomerPositionListItem = new CustomerPositionListItem({
                creatAt,
                CustomerPositionDetail,
                Enrolment: rs.length
              })
              mCustomerPositionListItems.push(mCustomerPositionListItem)
            })
            console.log(mCustomerPositionListItems)
            setCustomerPositionListItems(mCustomerPositionListItems)

            var mReqContractorAttendance = new ReqContractorAttendance({})
            mReqContractorAttendance.fromJson(contractorAttendance)
            mReqContractorAttendance.info.salaryHourly.CustomerPositionListItems = mCustomerPositionListItems
            mReqContractorAttendance.info.salaryHourly.RecruitmentList = RecruitmentList
            mReqContractorAttendance.setData(creatName)
            setContractorAttendance(mReqContractorAttendance)
            console.log(mReqContractorAttendance)

            toSave(mReqContractorAttendance)
          },
          failure: (err) => {
            console.log(err)
            if (setIsLoading !== undefined)
              setIsLoading(false)
            //window.location.replace("/AdminManagerList");
          }
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    })
  }

  //取得單人資訊
  function getContractor(caseContractor) {
    if (customerContractId === undefined || customerContractId === "") return
    Swal.fire({
      type: 'warning',
      title: "是否 重新抓 此派遣工的系統紀錄",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      allowEscapeKey: false,
      allowOutsideClick: false
    }).then(function (result) {
      // console.log(result)
      if (result.value) {
        if (setIsLoading !== undefined)
          setIsLoading(true)
        var mReqContractorAttendanceRecruitmentContractor = new ReqContractorAttendanceRecruitmentContractor({
          customerContractId,
          caseContractor,
          wageType: WageType1,
          companyId,
          startDate,
          endDate
        })
        // console.log(mReqCustomerPositionList)
        api_getCustomerAttendance_CustomerPosition_Recruitment_Contractor({
          mReqContractorAttendanceRecruitmentContractor,
          success: (obj) => {
            console.log(obj)
            if (obj.recruitment !== undefined) {
              var list = JSON.parse(JSON.stringify(RecruitmentList))
              list.forEach((item, index, arr) => {
                  if (item.caseContractor === obj.recruitment.caseContractor) {
                    var caseInfo = new ReqRecruitmentContractorCaseInfo({})
                    caseInfo.fromJson(obj.recruitment.caseInfo)
                    var PositionInfo = new RespCustomerPositionInfo({})
                    PositionInfo.fromJson(obj.recruitment.info)
                    var mReqRecruitmentItem_SalaryHourly = new ReqRecruitmentItem_SalaryHourly({ Recruitment:obj.recruitment, caseInfo, PositionInfo, startDate, endDate })
                      arr[index] = mReqRecruitmentItem_SalaryHourly
                  }
              });
              setRecruitmentList(list)
            }
           
            setIsLoading(false)
          },
          failure: (err) => {
            console.log(err)
            if (setIsLoading !== undefined)
              setIsLoading(false)
            //window.location.replace("/AdminManagerList");
          }
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    })
  }

  useEffect(() => {
    // console.log(contractorAttendance)
  }, [contractorAttendance])

  function toCancel() {
    window.history.back();
  }
  function toSave(mReqContractorAttendance) {
    // console.log(mReqContractorAttendance)
    setIsLoading(true)
    mReqContractorAttendance.info.salaryHourly.Status = parseInt( Status)
    api_updateContractorAttendance({
      mReqContractorAttendance,
      success: () => {
        setContractorAttendance(mReqContractorAttendance)
        setVal2Token("salaryHourly", { salaryHourly: mReqContractorAttendance.info.salaryHourly, contractorAttendance }, tokenId)
        if (setIsLoading !== undefined) {
          setIsLoading(false)
        }
      },
      failure: () => {
        if (setIsLoading !== undefined)
          setIsLoading(false)
      }
    })
  }

  function toSaveAttachment(attachment){
    console.log(attachment)
    var mReqContractorAttendance = new ReqContractorAttendance({})
    mReqContractorAttendance.fromJson(contractorAttendance)
    mReqContractorAttendance.info.salaryHourly.attachment = attachment
    console.log(mReqContractorAttendance)
    toSave(mReqContractorAttendance)
  }

  function setSalaryHourly(setSalaryHourly) {

  }

  var mRespCustomerPositionDetail = new RespCustomerPositionDetail({})
  var superTitle = contractorAttendanceSOPName
  var title = "月薪型出勤及加減項登錄"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>招募資訊</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"建立時間"} val={creatAt} />
          <SingleText title={"建立者"} val={creatName} />
          <SingleText title={"起迄期間"} val={dates} />
          <SingleSelect title={"作業狀態"}
            val={Status}
            attr={contractorAttendanceStatusAttr_Register}
            action={setStatus}
            hasBlank={false}
            size={3}
          />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-3">
            <SearchButton name={"計算“上工人員”及“對應職缺”"} action={getPositionList} icon={""} />
          </div>
          <div className="col-md-3">
            <p></p>
            <strong>特別注意！ 按下後已經登錄的資料會遺失！   </strong>
          </div>
        </div>
      </div>
      <div className="row">
        {
          CustomerPositionListItems.map((position, index) => (
            <div className="col-md-12" key={position.CustomerPositionDetail.customerPositionId}>
              <div className="hr-line-dashed"></div>
              {/* {console.log(position)} */}
              {
                mRespCustomerPositionDetail.fromJson(position.CustomerPositionDetail)
              }
              {/* {console.log(mRespCustomerPositionDetail)}
              {console.log(position)} */}
              <div className="col-md-3">
                <p></p>
                <p className="text-success">{position.creatAt}</p>
              </div>

              <div className="col-md-9">
                <p className="text-success">
                  {mRespCustomerPositionDetail.info.shift} /&nbsp;
                  {mRespCustomerPositionDetail.info.job} /&nbsp;
                  {position.Enrolment}人 /&nbsp;
                  請款金額 {Number(mRespCustomerPositionDetail.info.wageInfo.InvoiceHourlyWage1).toLocaleString('en-US')} 、&nbsp;
                  {Number(mRespCustomerPositionDetail.info.wageInfo.InvoiceHourlyWage2).toLocaleString('en-US')} 、&nbsp;
                  {Number(mRespCustomerPositionDetail.info.wageInfo.InvoiceHourlyWage3).toLocaleString('en-US')} 、&nbsp;
                  {Number(mRespCustomerPositionDetail.info.wageInfo.InvoiceHourlyWage4).toLocaleString('en-US')} /&nbsp;
                  給付金額{Number(mRespCustomerPositionDetail.info.wageInfo.PayHourlyWage1).toLocaleString('en-US')} 、&nbsp;
                  {Number(mRespCustomerPositionDetail.info.wageInfo.PayHourlyWage2).toLocaleString('en-US')} 、&nbsp;
                  {Number(mRespCustomerPositionDetail.info.wageInfo.PayHourlyWage3).toLocaleString('en-US')} 、&nbsp;
                  {Number(mRespCustomerPositionDetail.info.wageInfo.PayHourlyWage4).toLocaleString('en-US')} /&nbsp;
                  家庭照顧金 {mRespCustomerPositionDetail.info.wageInfo.ExtraPayeHourlyWage} /&nbsp;
                  營業稅 {getBusinessTaxTypeString(mRespCustomerPositionDetail.info.wageInfo.BusinessTaxType)}
                </p>
                <p className="text-success">
                  勞健保：{getInsuranceBurdenTypeString(mRespCustomerPositionDetail.info.wageInfo.InsuranceBurdenType)} / &nbsp;
                  團保：{getGroupInsuranceTypeString(mRespCustomerPositionDetail.info.insuranceInfo.groupInsuranceType)} &nbsp;
                  {getInsuranceBurdenTypeString(mRespCustomerPositionDetail.info.insuranceInfo.InsuranceBurdenType)} &nbsp;
                  每日保費 {mRespCustomerPositionDetail.info.insuranceInfo.groupInsurancePremium}元</p>
                <p className="text-success">
                  {
                    mRespCustomerPositionDetail.info.wageInfo.SalaryAddItem.map((item => (
                      item.text + " / "
                    )))
                  }
                </p><p className="text-success">
                  {
                    mRespCustomerPositionDetail.info.wageInfo.SalarySubtractItem.map((item => (
                      item.text + " / "
                    )))
                  }
                </p>
              </div>
            </div>
          ))
        }

      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-10">
            <strong>特別注意！ 如果加減項欄位不同無法計算！ 請先回“職缺設定”修正後再進行登錄！   </strong>
          </div>

        </div>
      </div>
    </>



  return (
    <>
      <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} hasDrawer={false} />
      {RecruitmentList.length === 0 ? <></> :
        <>
          <ContractorAttendanceRegisterAttachment attachment={attachment} save={toSaveAttachment} isEdit={true} />
          <ContractorAttendanceRegisterHourlyRecruitmentList recruitmentList={RecruitmentList} contractorAttendance={contractorAttendance} toSave={toSave} getContractor={getContractor} />
        </>
      }
    </>
  )
}

